import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconArrowLeftSvg } from "./IconArrowLeftSvg.mjs";
const IconArrowLeft = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconArrowLeftSvg, ...iconProps });
};
export {
  IconArrowLeft
};
